module.exports = __webpack_public_path__ + "static/media/04.299345c1.jpg";